<template>
  <div>
    <h3 class="c-orange pb-15 fs-24">3. Confirme seus segmentos</h3>
    <div class="form-group">
      <label class="font-weight-bold" for="id_cidades_atuacao">
        Seus segmentos estão corretos?
      </label>
      <b-row>
        <b-col
          cols="12"
          sm="12"
          md="6"
          lg="6"
          v-for="(shopkeeperSegment, index) in shopkeeperSegments"
          :key="index"
        >
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12">
          <b-button
            variant="success"
            class="bg-orange text-white"
            @click="selectIndex = false"
          >
            Sim
          </b-button>
          <b-button
            variant="danger"
            class="bg-orange text-white"
            @click="selectIndex = true"
          >
            Não
          </b-button>
          {{ segmentosUsuario }}
        </b-col>
      </b-row>
      <div
        class="row m-0 mt-3"
        v-if="segmentosUsuario !== null || segmentosUsuario !== []"
      >
        <div
          class="col-6 p-0"
          v-for="(segmento, index) in segmentosUsuario"
          :key="index"
        >
          <div
            v-if="selectIndex === true"
            class="btn-remove"
            @click="excluirSegmentos(index)"
          >
            <i class="fas fa-times"></i>
          </div>
          <v-select
            class="seg-alt p-right-10px m-1"
            label="nome"
            :options="listSegments"
            :reduce="(segment) => segment.id"
            v-model="segmentosUsuario[index].segmento.nome"
          ></v-select>
        </div>
        <div
          class="btn btn-success"
          v-if="selectIndex === true"
          @click="adicionarSegmentos(index)"
        >
          <i class="fas fa-plus"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ShopkeeperConfirmSegments',
  computed: {
    ...mapState({
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      estados: (state) => state.estados,
      cidades: (state) => state.cidades,
      segmentos: (state) => state.segmentos,
      segmentosUsuario: (state) => state.dadosUsuario.informacoes.segmentos,
    }),
    ...mapState('general', ['segments']),
  },
  mounted() {
    this.getAllSegments().then(() => {
      this.listSegments = this.segments;
    });
  },
  methods: {
    ...mapActions('general', ['getAllSegments']),
    validate() {
      let isValid = true;

      if (this.selectIndex === false) {
        return isValid;
      }

      if (this.Fields.id_segmentos_atuacao.length === 0) {
        this.ErrorMessages.actuation_segments =
          'Você não selecionou nenhum segmento de atuação';
        isValid = false;
      }
      return isValid;
    },
    excluirSegmentos(index) {
      this.segmentosUsuario.splice(index, 1);
    },
    adicionarSegmentos(index) {
      this.segmentosUsuario.push(index, 1);
    },
  },
  data() {
    return {
      listSegments: [],
      Fields: {
        id_segmentos_atuacao: [],
      },
      ErrorMessages: {
        actuation_segments: null,
      },
      selectIndex: false,
      shopkeeperSegments: [],
    };
  },
};
</script>
